let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jOEwf")).then(() => parcelRequire('1N09d'));